<template >
    <div v-if="shopBool" class="shop">
        <div class="shop-cart">
            <img class="shop-cart__close" src="../../assets/img/close.svg" alt="" @click="$emit('shopFalse',false)">
            <h2 class="shop-cart__title">Savat</h2>
            <hr>
            <div class="shop-cart__boxs">
                <div class="shop-cart__boxs-box" v-for="(cart,i) in shop" :key="i">
                    <img @click="delCard(i,cart.id)" class="shop-cart__boxs-box__delete" src="../../assets/img/delete-1.svg" alt="">
                    <img class="shop-cart__boxs-box__img" :src="cart.img" alt="">
                    <p class="shop-cart__boxs-box__text">{{cart.title}}</p>
                    <div class="shop-cart__boxs-box__info">
                        <p class="shop-cart__boxs-box__info-price">{{cart.price * cart.amount}}</p>
                        <div class="shop-cart__boxs-box__info-plusOrMinus">
                            <button @click="changeCart('-',cart.id)">-</button>
                            <p>{{cart.amount}}</p>
                            <button @click="changeCart('+',cart.id)">+</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        shop:Array,
        shopBool:Boolean,
    },
    methods:{
        delCard(i,id){
            this.shop.forEach((card,index) => {
                if (i == index) {
                    this.shop.splice(i,1)
                }
            });
            this.$emit('delCard',id)
        },
        changeCart(change,id){
            this.$emit('changeCart',{
                id: id,
                change: change
            })
        }
    }
}
</script>
<style lang="scss">
    
</style>